import * as _ from 'lodash';
import moment from 'moment';
// import * as str from 'underscore.string';

export const TranformtionPolicyRulesServerToClientFilterObject = {
    "name": "policyRulesServerToClient",
    "filter": [() => {
        return (inputJson, metaData) => {
            let outputJson = Object.assign({}, inputJson);
            outputJson.MetaData = {
                Rules: {
                    Categories: (metaData.categories) ? _.sortBy(metaData.categories, o => o.Value.toLowerCase()) : [],
                    RuleType: metaData.ruleTypes,
                },
                TimeZones: metaData.timeZones,
                DbType: metaData.dbTypes,
            };
            const dbTypes = [];
            let category = {};
            let ruleTypeDef = {};
            if (!outputJson.isNew) {
                _.each(outputJson.dbTypes, dbType => {
                    const matchedType = _.find(outputJson.MetaData.DbType, mtype => mtype.Key == dbType.Key);
                    if (matchedType) {
                        dbTypes.push(matchedType);
                    }
                })
                if (outputJson.category) {
                    const matchedCategory = _.find(outputJson.MetaData.Rules.Categories, cat => cat.Key == outputJson.category.Key);
                    if (matchedCategory) {
                        category = matchedCategory;
                    }
                }

                const matchedRuleType = _.find(outputJson.MetaData.Rules.RuleType, ruleType => ruleType.Key == outputJson.typeId);
                if (matchedRuleType) {
                    ruleTypeDef = matchedRuleType;
                    outputJson.TimingMode = false;
                    if (outputJson.typeId == 1) {
                        outputJson.TimingMode = true;
                    }
                }

                if (outputJson.endTime) {
                    outputJson.endDateObj = outputJson.endTime;
                }

                if (outputJson.startTime) {
                    outputJson.startDateObj = outputJson.startTime;
                }
                if (outputJson.TimingMode) {
                    if (outputJson.days) {
                        const daysDef = _.map(outputJson.days.split(','), day => parseInt(day));
                        outputJson.Days = {
                            Sunday: daysDef[0],
                            Monday: daysDef[1],
                            Tuesday: daysDef[2],
                            Wenesday: daysDef[3],
                            Thursday: daysDef[4],
                            Friday: daysDef[5],
                            Saturday: daysDef[6]
                        }
                    } else outputJson.Days = {}
                    if (outputJson.utcShift) {
                        const matchedTZ = _.find(outputJson.MetaData.TimeZones, tz => tz.Key == outputJson.utcShift);
                        outputJson.utcShiftSelection = {};
                        if (matchedTZ) {
                            outputJson.utcShiftSelection = matchedTZ
                        }
                    }
                } else {
                    outputJson.isSensitive = outputJson.isSensitive || false;
                }

                outputJson.CategorySelection = category
                outputJson.DBTypeSelection = dbTypes
                outputJson.RuleTypeSelection = ruleTypeDef;
            }
            outputJson.createdDate = moment.utc(outputJson.createDate).local().format('DD/MM/YYYY');
            return [outputJson];
        };
    }]
};



// WEBPACK FOOTER //
// ./src/app/authorized/policyEngine/transofromtions/trans.policyRulesServerToClient.js